import _ from '@rover/globals/underscore';
import Backbone from '@rover/globals/backbone';
import { isMobileEmbedded } from '@rover/utilities/userAgent';
import { closeDialog } from '@rover/utilities/embedded';

import CreditCardModel from './CreditCardModel';

export default Backbone.Collection.extend({
  model: CreditCardModel,
  initialize(options = {}) {
    _.bindAll(this, 'addNewCC');
    this.closeOnAddNewCC = options.closeOnAddNewCC || false;
  },
  addNewCC({ url }) {
    const newCCModel = new CreditCardModel({ instanceUrl: url });
    const that = this;

    that.closeMobileEmbedded();

    newCCModel.fetch({
      success(model, creditCard) {
        that.add(new CreditCardModel(creditCard));
      },
    });
  },
  closeMobileEmbedded() {
    if (isMobileEmbedded() && this.closeOnAddNewCC) {
      closeDialog();
    }
  },
});



// WEBPACK FOOTER //
// ./js/backbone/models/CreditCardCollection.js